import React, { useState, useCallback } from 'react';
import { Button } from '../ui';
import { cn } from '../../utils';
import type { LoginCredentials } from '../../types/auth';
import './LoginPage.css';

interface LoginPageProps {
  onLogin: (credentials: LoginCredentials) => Promise<void>;
  error: string | null;
  onClearError: () => void;
  isLoading: boolean;
  className?: string;
}

export const LoginPage: React.FC<LoginPageProps> = ({
  onLogin,
  error,
  onClearError,
  isLoading,
  className,
}) => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = useCallback(
    async (e: React.FormEvent) => {
      e.preventDefault();
      onClearError();
      try {
        await onLogin({ login: login.trim(), password });
      } catch {
        // error already set in useAuth
      }
    },
    [onLogin, login, password, onClearError]
  );

  return (
    <div className={cn('login-page', className)}>
      <div className="login-page__card">
        <h1 className="login-page__title">Вход</h1>
        <p className="login-page__subtitle">
          Введите логин и пароль.
        </p>

        <form className="login-page__form" onSubmit={handleSubmit}>
          <label className="login-page__label">
            Логин
            <input
              type="text"
              className="login-page__input"
              value={login}
              onChange={e => setLogin(e.target.value)}
              autoComplete="username"
              placeholder="Логин"
              disabled={isLoading}
            />
          </label>
          <label className="login-page__label">
            Пароль
            <input
              type="password"
              className="login-page__input"
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete="current-password"
              placeholder="Пароль"
              disabled={isLoading}
            />
          </label>

          {error && (
            <div className="login-page__error" role="alert">
              {error}
            </div>
          )}

          <Button
            type="submit"
            className={cn(
              'login-page__submit',
              login.trim() && password && 'login-page__submit--filled'
            )}
            disabled={isLoading || !login.trim() || !password}
          >
            {isLoading ? 'Вход...' : 'Войти'}
          </Button>
        </form>
      </div>
    </div>
  );
};
